import { render, staticRenderFns } from "./TestInformationDetail.vue?vue&type=template&id=4fbe8b04&scoped=true"
import script from "./TestInformationDetail.vue?vue&type=script&lang=js"
export * from "./TestInformationDetail.vue?vue&type=script&lang=js"
import style0 from "./TestInformationDetail.vue?vue&type=style&index=0&id=4fbe8b04&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbe8b04",
  null
  
)

export default component.exports